(() => {
  if (window.HouseIXHouseSwitch) return;
  window.HouseIXHouseSwitch = true;
  const root = document.querySelector('[data-hix-house-switch]');
  if (!root) return;
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  let navigationTimer = 0;
  let cleanupTimer = 0;
  let destination = null;
  let departing = false;
  const houseAt = path => path.match(/(?:^|\/)(?:pages|collections)\/house-of-(vanta|ember|aether|tide)(?:\/|$)/)?.[1] || null;
  const disabled = () => preference.matches || document.body.dataset.hixMotion === 'paused';
  const reset = () => {
    clearTimeout(navigationTimer);
    clearTimeout(cleanupTimer);
    root.hidden = true;
    root.dataset.phase = 'idle';
    departing = false;
    destination = null;
  };
  const show = (house, phase) => {
    root.dataset.house = house;
    root.dataset.phase = phase;
    const identity = root.querySelector('[data-switch-identity="' + house + '"]');
    root.querySelector('[data-switch-live]').textContent = identity?.dataset.entering || '';
    root.hidden = false;
  };
  const arrive = () => {
    const house = houseAt(window.location.pathname);
    if (!house || disabled()) return;
    show(house, 'arriving');
    cleanupTimer = setTimeout(reset, 2650);
  };
  const navigate = () => {
    const url = destination;
    if (!url) return;
    try {
      window.location.assign(url);
      cleanupTimer = setTimeout(reset, 3500);
    } catch {
      reset();
    }
  };
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || disabled()) return;
    const link = event.target.closest?.('a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    let url;
    try { url = new URL(link.href, window.location.href); } catch { return; }
    if (url.origin !== window.location.origin) return;
    const house = houseAt(url.pathname);
    if (!house || house === houseAt(window.location.pathname) || url.pathname === window.location.pathname) return;
    event.preventDefault();
    event.stopPropagation();
    if (departing) return;
    reset();
    departing = true;
    destination = url.href;
    show(house, 'departing');
    navigationTimer = setTimeout(navigate, 600);
  }, {capture: true});
  window.addEventListener('pagehide', reset);
  window.addEventListener('pageshow', event => {
    if (event.persisted) {
      reset();
      arrive();
    }
  });
  preference.addEventListener('change', () => {
    if (!preference.matches) return;
    const url = destination;
    reset();
    if (url) window.location.assign(url);
  });
  new MutationObserver(() => {
    if (!disabled()) return;
    const url = destination;
    reset();
    if (url) window.location.assign(url);
  }).observe(document.body, {attributes: true, attributeFilter: ['data-hix-motion']});
  arrive();
})();
